// © Microsoft Corporation. All rights reserved.
/**
 * Enterprise flights that are relevant to WPO
 */
export const wpoEnterpriseFlights = ["prg-wpo-rentin-t", "prg-wpo-northstr", "prg-northstar", "prg-webcomp-ent"];
//# sourceMappingURL=Constants.js.map